import { useMemo } from "react";
import { useSearchParams } from "next/navigation";

interface ICatGender {
  catGenderHisHerTheir: string;
  catGenderHimHerThem: string;
  catGenderHeSheThey: string;
}

export const useCatGenderFromQuery = (): ICatGender => {
  const searchParams = useSearchParams();

  const [ catGenderHisHerTheir, catGenderHimHerThem, catGenderHeSheThey ] = useMemo(() => {
    const param = searchParams.get("allCatGenders");
    if (param === "Boy") {
      return [ "his", "him", "he" ];
    } if (param === "Girl") {
      return [ "her", "her", "she" ];
    }
    return [ "their", "them", "they" ];

  }, [ searchParams ]);

  return {
    catGenderHisHerTheir,
    catGenderHimHerThem,
    catGenderHeSheThey,
  };
};
